import {lending_store_open_primary, lending_store_open_page} from "../actions/page";

const initialState = {
    page: 'primary',
};

export const lendingReducer = function (state = initialState, action) {
    switch (action.type) {
        case lending_store_open_primary: {
            return {
                ...state,
                page: 'primary'
            }
        }
        case lending_store_open_page: {
            return {
                ...state,
                page: action.data
            }
        }
        default:
            return state;
    }
};